module.exports = __webpack_public_path__ + "img/rowawi.2c68b8f3.jpg";